import React from "react";
import LibraryLogo from "../Library.svg";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row row__column">
          <a href="/">
            <figure className="footer__logo">
              <img
                src={LibraryLogo}
                className="footer__logo--img"
                alt="Library Logo"
              />
            </figure>
          </a>
          <div className="footer__list">
            <a href="/" className="footer__link">
              Home
            </a>
            <a
              href="/"
              className="footer__link no-cursor"
              aria-disabled="true"
              tabIndex={-1}
              onClick={(event) => event.preventDefault()}
            >
              About
            </a>
            <a href="/books" className="footer__link">
              Books
            </a>
            <a href="/cart" className="footer__link">
              Cart
            </a>
          </div>
          <div className="footer__copyright">Copyright © 2026 Library</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
